    <aside
      class="jl-sidebar flex w-full flex-col border-r border-[var(--color-border)] bg-[var(--color-sidebar-bg)] transition-[width,padding] duration-200 ease-out"
      [class.h-screen]="!mobile()"
      [class.h-full]="mobile()"
      [class.jl-sidebar--collapsed]="isDesktopCollapsed()"
    >
      <!-- Brand -->
      @if (isDesktopCollapsed()) {
        <div class="flex flex-col items-center gap-2 py-4">
          <img src="/assets/icons/jestiyon.svg" class="w-3 cursor-pointer" alt="" jlClickable [attr.aria-label]="'nav.aria.goToDashboard' | transloco" (click)="navigateDashboard()">
          <!-- <lucide-icon [img]="brandIcon" [size]="28" class="text-[var(--color-primary)]" aria-hidden="true" /> -->
          @if (!mobile()) {
            <button
              data-testid="sidebar-collapse-button"
              type="button"
              class="flex h-8 w-8 items-center justify-center rounded-lg text-[var(--color-text-muted)] transition-colors hover:bg-[var(--color-sidebar-hover)] hover:text-[var(--color-text-secondary)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
              [attr.aria-label]="'nav.aria.expandMenu' | transloco"
              (click)="onToggleCollapse()"
            >
              <lucide-icon [img]="expandSidebarIcon" [size]="18" aria-hidden="true" />
            </button>
          }
        </div>
      } @else {
        <div class="flex items-center justify-between px-5 py-5" >
          <div class="flex items-center cursor-pointer" jlClickable [attr.aria-label]="'nav.aria.goToDashboard' | transloco" (click)="navigateDashboard()">
            <img src="/assets/icons/jestiyon.svg" class="w-5 h-5" alt="">
            <span class="text-base font-semibold text-[var(--color-primary)]">JestyLine</span>
          </div>
          @if (!mobile()) {
            <button
              data-testid="sidebar-collapse-button"
              type="button"
              class="flex h-8 w-8 items-center justify-center rounded-lg text-[var(--color-text-muted)] transition-colors hover:bg-[var(--color-sidebar-hover)] hover:text-[var(--color-text-secondary)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
              [attr.aria-label]="'nav.aria.collapseMenu' | transloco"
              (click)="onToggleCollapse()"
            >
              <lucide-icon [img]="collapseSidebarIcon" [size]="18" aria-hidden="true" />
            </button>
          }
        </div>
      }

      <!-- Navigation -->
      <nav
        class="flex-1 overflow-y-auto pt-2 pb-4"
        [class.px-3]="!isDesktopCollapsed()"
        [class.px-2]="isDesktopCollapsed()"
        [attr.aria-label]="'nav.aria.mainMenu' | transloco"
      >
        <div class="space-y-4">
          @for (section of navSections(); track section.header) {
            <section>
              @if (!isDesktopCollapsed() && section.header) {
                <h2 class="px-3 pb-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-[var(--color-text-muted)]">
                  {{ section.header | transloco }}
                </h2>
              }
              <ul class="space-y-0.5">
                @for (item of section.items; track item.path) {
                  <li>
                    <a
                      [routerLink]="isLocked(item) ? null : item.path"
                      [attr.data-demo]="'nav-' + item.path.slice(1)"
                      routerLinkActive="jl-nav-active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      [class.jl-nav-hmrc]="item.iconId === 'hmrc'"
                      [class.jl-nav-locked]="isLocked(item)"
                      [class.jl-nav-locked--soon]="item.badge === 'soon'"
                      (click)="isLocked(item) ? onLockedClick(item, $event) : null"
                      class="group relative flex items-center rounded-xl py-2.5 text-[13px] text-[var(--color-sidebar-text)]
                             transition-all duration-150 hover:bg-[var(--color-sidebar-hover)] hover:text-[var(--color-text)]
                             focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                      [class.px-3]="!isDesktopCollapsed()"
                      [class.px-2]="isDesktopCollapsed()"
                      [class.gap-3]="!isDesktopCollapsed()"
                      [class.gap-0]="isDesktopCollapsed()"
                      [class.justify-center]="isDesktopCollapsed()"
                      [pTooltip]="isDesktopCollapsed()
                        ? (item.label | transloco)
                        : (item.badge === 'soon'
                            ? ('nav.soon.tooltip' | transloco)
                            : (item.badge === 'upgrade' ? ('nav.upgrade.description' | transloco) : ''))"
                      [tooltipDisabled]="!isDesktopCollapsed() && !item.badge"
                      tooltipPosition="right"
                      [attr.aria-label]="isDesktopCollapsed() ? (item.label | transloco) : null"
                    >
                      <lucide-icon
                        class="h-[18px] w-[18px] shrink-0"
                        [attr.data-icon-id]="item.iconId"
                        [img]="iconMap[item.iconId]"
                        [size]="18"
                        [strokeWidth]="2"
                      />
                      @if (!isDesktopCollapsed()) {
                        <span class="jl-nav-label" [class.jl-nav-hmrc-label]="item.iconId === 'hmrc'">{{ item.label | transloco }}</span>
                        @if (item.showPendingBadge && pendingBankFeedCount() > 0) {
                          <span class="jl-nav-badge">{{ pendingBankFeedCount() }}</span>
                        } @else if (item.badge === 'soon') {
                          <span class="jl-nav-badge jl-nav-badge--soon">{{ 'nav.badges.soon' | transloco }}</span>
                        } @else if (item.badge === 'upgrade') {
                          <span class="jl-nav-badge jl-nav-badge--upgrade">
                            <lucide-icon [img]="upgradeIcon" [size]="12" [strokeWidth]="2.25" aria-hidden="true" />
                            {{ 'nav.badges.upgrade' | transloco }}
                          </span>
                        }
                      } @else if (item.showPendingBadge && pendingBankFeedCount() > 0) {
                        <span class="jl-nav-badge-dot" aria-hidden="true"></span>
                      } @else if (item.badge) {
                        <span class="jl-nav-badge-dot" [class.jl-nav-badge-dot--soon]="item.badge === 'soon'" [class.jl-nav-badge-dot--upgrade]="item.badge === 'upgrade'" aria-hidden="true"></span>
                      }
                    </a>
                  </li>
                }
              </ul>
            </section>
          }
        </div>
      </nav>

      <!-- Footer / User -->
      <div
        class="jl-user-card-wrapper relative border-t border-[var(--color-border)] py-4"
        [class.px-4]="!isDesktopCollapsed()"
        [class.px-2]="isDesktopCollapsed()"
      >
        <!-- Backdrop -->
        @if (userMenuOpen()) {
          <div class="jl-user-menu-backdrop" (click)="closeUserMenu()"></div>
        }

        <!-- Dropdown Menu -->
        @if (userMenuOpen()) {
          <div class="jl-user-menu">
            <!-- Company list (only show when more than 1 company) -->
            @if (companies().length > 1) {
              <div class="jl-user-menu-section-label">{{ 'nav.userMenu.switchCompany' | transloco }}</div>
              <div class="jl-user-menu-companies">
                @for (company of companies(); track company.publicId) {
                  <button
                    type="button"
                    class="jl-user-menu-item"
                    [class.jl-user-menu-item--active]="isActiveCompany(company)"
                    (click)="switchCompany(company)"
                  >
                    <span class="truncate">{{ company.name }}</span>
                    @if (needsOnboarding(company)) {
                      <lucide-icon [img]="pendingIcon" [size]="14" class="jl-user-menu-item-pending" />
                    }
                  </button>
                }
              </div>
              <div class="jl-user-menu-separator"></div>
            }

            <!-- Add Company -->
            <button type="button" class="jl-user-menu-item" (click)="addCompany()">
              <lucide-icon [img]="plusIcon" [size]="14" class="shrink-0" />
              <span>{{ 'nav.userMenu.addCompany' | transloco }}</span>
            </button>

            @if (isAccountant()) {
              <div class="jl-user-menu-separator"></div>

              <!-- Switch to Accountant Panel -->
              <button type="button" class="jl-user-menu-item" (click)="goAccountantPanel()">
                <lucide-icon [img]="accountantPanelIcon" [size]="14" class="shrink-0" />
                <span>{{ 'nav.userMenu.accountantPanel' | transloco }}</span>
              </button>
            }

            <div class="jl-user-menu-separator"></div>

            <!-- Sign Out -->
            <button type="button" class="jl-user-menu-item jl-user-menu-item--danger" (click)="signOut()">
              <lucide-icon [img]="logOutIcon" [size]="14" class="shrink-0" />
              <span>{{ 'nav.userMenu.signOut' | transloco }}</span>
            </button>
          </div>
        }

        <!-- User Card Button -->
        <button
          type="button"
          class="flex w-full items-center rounded-xl px-2 py-2 transition-colors hover:bg-[var(--color-sidebar-hover)] cursor-pointer"
          [class.gap-3]="!isDesktopCollapsed()"
          [class.justify-center]="isDesktopCollapsed()"
          [attr.title]="isDesktopCollapsed() ? userName() : null"
          (click)="toggleUserMenu()"
        >
          <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--color-primary)] text-xs font-semibold text-white">
            {{ userInitials() }}
          </div>
          @if (!isDesktopCollapsed()) {
            <div class="min-w-0 flex-1 text-left">
              <div class="truncate text-sm font-medium text-[var(--color-text)]">{{ userName() }}</div>
              <div class="truncate text-xs text-[var(--color-text-muted)]">{{ selectedCompanyName() }}</div>
            </div>
            <lucide-icon [img]="userMenuIcon" [size]="16" class="shrink-0 text-[var(--color-text-muted)]" aria-hidden="true" />
          }
        </button>
      </div>
    </aside>
